import { render, staticRenderFns } from "./waring-bar.vue?vue&type=template&id=d06060de&scoped=true"
import script from "./waring-bar.vue?vue&type=script&lang=js"
export * from "./waring-bar.vue?vue&type=script&lang=js"
import style0 from "./waring-bar.vue?vue&type=style&index=0&id=d06060de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06060de",
  null
  
)

export default component.exports